var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-select',_vm._g({attrs:{"input":_vm.input,"options":_vm.customCertsList}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }